module.exports = __webpack_public_path__ + "static/img/bcg1.973ffb19.webp";